import { Badge } from '@/components/ui/badge'
import { Separator } from '@/components/ui/separator'
import { Wifi } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { ROUTE_TITLES } from '../config/route-titles'
import { DropDownTranslator } from './DropDownTranslator'
import { SidebarTrigger } from './ui/sidebar'

export function Header() {
  const { t } = useTranslation()
  const location = useLocation()
  const route = ROUTE_TITLES.find(r => r.match(location.pathname))
  const title = route ? t(route.titleKey) : 'MTrack'

  return (
    <header className="flex h-14 items-center gap-3 border-b border-border/50 px-4">
      <SidebarTrigger className="text-muted-foreground" />
      <Separator orientation="vertical" className="h-5" />
      <div className="flex flex-1 items-center justify-between">
        <div className="flex items-center gap-3">
          <h1 className="text-sm font-semibold text-foreground">{title}</h1>
          <Badge variant="outline" className="hidden text-[10px] text-primary border-primary/30 sm:inline-flex">
            <Wifi className="mr-1 size-2.5" />
            Live
          </Badge>
        </div>

        <DropDownTranslator />
      </div>
    </header>
  )
}
